import React from "react";
import AllPublisher from "../component/sections/publisher/AllPublisher";

const sitesRoutes = [
  {
    path: "/publisher/all",
    render: () => <AllPublisher />,
    exact: true,
  },
];

export default sitesRoutes;
